/*
  Used for FieldArrayDnd passing of formik submitForm function to parent
  !Every component using the hook must be wrapped in forwardRef
*/

import { useRef, useImperativeHandle } from 'react';

const useFormikForwardRef = (ref) => {
  const formikRef = useRef();
  useImperativeHandle(ref, () => (formikRef.current));
  return formikRef;
};

export default useFormikForwardRef;
